<template>
  <section class="">
    <div class="columns is-mobile">
      <div class="column is-7">
        <p class="strip is-info"></p>
      </div>
    </div>
    <div class="columns is-mobile">
      <div class="column is-offset-5 is-7">
        <p class="strip is-info"></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name : "Stripes"
}
</script>

<style lang="scss">

@import '../../static/_variables.scss';

.strip{
  border-radius: 3px;
  padding: 0.2rem;
  position: relative;
  border:5px solid $stipe-color;
}
</style>



// WEBPACK FOOTER //
// src/componests/Stripes.vue